"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createTypingIndicatorStyle;

function createTypingIndicatorStyle(_ref) {
  var paddingRegular = _ref.paddingRegular;
  return {
    paddingBottom: paddingRegular,
    '&:not(.webchat__typingIndicator--rtl)': {
      paddingLeft: paddingRegular
    },
    '&.webchat__typingIndicator--rtl': {
      paddingRight: paddingRegular
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJjcmVhdGVUeXBpbmdJbmRpY2F0b3JTdHlsZSIsInBhZGRpbmdSZWd1bGFyIiwicGFkZGluZ0JvdHRvbSIsInBhZGRpbmdMZWZ0IiwicGFkZGluZ1JpZ2h0Il0sInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvU3R5bGVzL1N0eWxlU2V0L1R5cGluZ0luZGljYXRvci50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBTdHJpY3RTdHlsZU9wdGlvbnMgfSBmcm9tICdib3RmcmFtZXdvcmstd2ViY2hhdC1hcGknO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBjcmVhdGVUeXBpbmdJbmRpY2F0b3JTdHlsZSh7IHBhZGRpbmdSZWd1bGFyIH06IFN0cmljdFN0eWxlT3B0aW9ucykge1xuICByZXR1cm4ge1xuICAgIHBhZGRpbmdCb3R0b206IHBhZGRpbmdSZWd1bGFyLFxuXG4gICAgJyY6bm90KC53ZWJjaGF0X190eXBpbmdJbmRpY2F0b3ItLXJ0bCknOiB7XG4gICAgICBwYWRkaW5nTGVmdDogcGFkZGluZ1JlZ3VsYXJcbiAgICB9LFxuXG4gICAgJyYud2ViY2hhdF9fdHlwaW5nSW5kaWNhdG9yLS1ydGwnOiB7XG4gICAgICBwYWRkaW5nUmlnaHQ6IHBhZGRpbmdSZWd1bGFyXG4gICAgfVxuICB9O1xufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBRWUsU0FBU0EsMEJBQVQsT0FBNEU7RUFBQSxJQUF0Q0MsY0FBc0MsUUFBdENBLGNBQXNDO0VBQ3pGLE9BQU87SUFDTEMsYUFBYSxFQUFFRCxjQURWO0lBR0wseUNBQXlDO01BQ3ZDRSxXQUFXLEVBQUVGO0lBRDBCLENBSHBDO0lBT0wsbUNBQW1DO01BQ2pDRyxZQUFZLEVBQUVIO0lBRG1CO0VBUDlCLENBQVA7QUFXRCJ9